import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { CourseDateCombined } from "@shared/models/course-date-combined"
import type CourseCalendarEditor from "cc-frontend/services/course-calendar-editor"
import type EmberStore from "cc-frontend/services/ember-store"

interface Args {
  dateString: string
  course: Course
  courseDate: CourseDateCombined
  onToggle: Function
}

export default class CourseToggle extends Component<Args> {
  @service("ember-store") store!: EmberStore
  @service courseCalendarEditor!: CourseCalendarEditor

  @action
  toggleIsOff() {
    this.courseCalendarEditor.toggleCustomDate(
      this.args.course,
      this.args.dateString,
      this.args.courseDate.isOff,
      this.args.courseDate.isForcedOn
    )
    if (document && document.activeElement) (document.activeElement as HTMLElement).blur()

    if (this.args.onToggle) this.args.onToggle()
  }
}
